import Vue from 'vue';

const LOGIN_ROUTE_NAME = 'login';
const REDIRECT_PARAM_NAME = 'redirect';
const REQUIRES_AUTH_META_NAME = 'requiresAuth';

export default (to, from, next) => {
  const isLoggedIn = Vue.ls.get('isLoggedIn');

  if (to.matched.some(record => record.meta[REQUIRES_AUTH_META_NAME])) {
    if (!isLoggedIn) {
      next({
        name: LOGIN_ROUTE_NAME,
        query: { [REDIRECT_PARAM_NAME]: to.fullPath },
      });
    } else {
      next();
    }
  } else if (isLoggedIn) {
    if (to.matched.some(record => record.name === LOGIN_ROUTE_NAME)) {
      if (to.query && to.query[REDIRECT_PARAM_NAME]) {
        next({ path: to.query[REDIRECT_PARAM_NAME] });
      } else {
        next({ path: '/' });
      }
    } else {
      next();
    }
  } else {
    next();
  }
};
